/**
 * @file コンポーネント：フル動画ページ リンクボタン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledContents = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 8px;
    margin-bottom: 16px;
`;
